import React, { useEffect } from "react";
import { registerResource, loadByPriority } from "../../utils/resourceManager";

interface FirstScreenOptimizerProps {
  children: React.ReactNode;
  criticalResources?: Array<{
    id: string;
    type: "image" | "script" | "style" | "component";
    url?: string;
    importFunc?: () => Promise<any>;
  }>;
  highPriorityResources?: Array<{
    id: string;
    type: "image" | "script" | "style" | "component";
    url?: string;
    importFunc?: () => Promise<any>;
  }>;
}

const FirstScreenOptimizer: React.FC<FirstScreenOptimizerProps> = ({
  children,
  criticalResources = [],
  highPriorityResources = [],
}) => {
  useEffect(() => {
    const loadFirstScreenResources = async () => {
      try {
        // 注册关键资源
        criticalResources.forEach((resource) => {
          registerResource({
            ...resource,
            priority: "critical",
            preload: true,
          });
        });

        // 注册高优先级资源
        highPriorityResources.forEach((resource) => {
          registerResource({
            ...resource,
            priority: "high",
            preload: true,
          });
        });

        // 在后台加载关键资源
        loadByPriority("critical");

        // 在后台加载高优先级资源
        loadByPriority("high");
      } catch (error) {
        console.error("Failed to load first screen resources:", error);
      }
    };

    loadFirstScreenResources();
  }, [criticalResources, highPriorityResources]);

  // 直接返回子组件，不显示加载状态
  return <>{children}</>;
};

export default FirstScreenOptimizer;
